import type { User } from 'oidc-client-ts';
import { dataCache } from './dataCache';

class AuthEventListener {
    private static instance: AuthEventListener;

    private constructor() {}

    public static getInstance(): AuthEventListener {
        if (!AuthEventListener.instance) {
            AuthEventListener.instance = new AuthEventListener();
        }
        return AuthEventListener.instance;
    }

    public onUserLoaded = (_user: User) => {
        dataCache.clear();
    };

    public onUserUnloaded = () => {
        dataCache.clear();
    };

    public onUserSignedOut = () => {
        dataCache.clear();
    };
}

export const authEventListener = AuthEventListener.getInstance();
